import axios from 'axios'

const baseURL = process.env.REACT_APP_SURIDATA_API_URL
const gcsAutomateURL = process.env.REACT_APP_SURIDATA_AUTOMATE_API_URL
const suridataApiURL = process.env.REACT_APP_SURIDATA_CREDENTIALS_API_URL

const api = axios.create({
    baseURL: baseURL
})

const gcsAutomateApi = axios.create({
    baseURL: gcsAutomateURL
})

const suridataApi = axios.create({
    baseURL: suridataApiURL,
    headers: { 
        'Authorization': localStorage.getItem('token')
    }
})

// eslint-disable-next-line
export { api, baseURL, gcsAutomateApi, suridataApi };